<template>
	<div style="height: 100%;">
		<k-panel fill-height searchable :addable="$is_admin()" v-on:add="open_add" v-on:search="search_text = $event">
			<template v-slot:left-buttons>
				<k-tabs v-model="selected_tab" large>
					<k-tab name="input" label="Inputs"></k-tab>
					<k-tab name="output" label="Outputs"></k-tab>
					<k-tab name="headend" label="Headends"></k-tab>
					<k-tab name="transcoder" label="Transcoders"></k-tab>
					<k-tab name="clipper" label="Clippers"></k-tab>
					<k-tab name="external_device" label="External devices"></k-tab>
					<k-tab name="mediamtx" label="MediaMTXs"></k-tab>
					<k-tab name="srt_server" label="SRT Servers"></k-tab>
					<k-tab name="analyzer" label="Analyzers"></k-tab>
				</k-tabs>
			</template>

			<k-data-table :headers="headers" :items="instance_list" fill-height :pagination.sync="pagination" :rows-per-page-items="[5, 15, 25, 50, 100, { text: 'All', value: -1 }]">
		      	<template slot="items" slot-scope="props">
		      		<tr>
			        	<td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ props.item.type }}</td>
			  	      	<td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ props.item.title }}</td>
		    	    	<td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ props.item.meta.channel | channel_name }}</td>
			      	  	<td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ get_field(props.item, ['system_info', 'ip'], '') }}</td>
		        		<td @click.stop="open_edit(props.item.id)" :class="{'grey lighten-4': props.item.state == 'archived'}">{{ get_field(props.item, ['system_info', 'version'], '') }}</td>
		        		<td class="hidden-sm-and-down" :class="{'grey lighten-4': props.item.state == 'archived'}" style="text-align: right; min-width: 190px; max-width: 190px; width: 190px;">
		        			<k-btn size="xs" flat @click.stop="open_gui(props.item)" v-if="is_gui(props.item.type)">GUI</k-btn>
        					<k-btn size="xs" flat @click.stop="open_ssh(props.item)">SSH</k-btn>
        				</td>
        			</tr>
      			</template>
			</k-data-table>
		</k-panel>
<!--		<action-buttons @add="open_add"></action-buttons>-->
	</div>
</template>

<script>
import Vue from 'vue'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'
import ActionButtons from '@/components/ActionButtons.vue'

export default {
	components: {
		ActionButtons
	},
	data () {
		return {
			channel: undefined,
			selected_tab: "input",
			headers: [
        { text: 'Type', value: 'type', align: 'left' },
        { text: 'Title', value: 'title', align: 'left' },
        { text: 'Channel', value: 'channel', align: 'left' },
        { text: 'Ip', value: 'ip', align: 'left' },
        { text: 'Version', value: 'version', align: 'left' },
        { text: 'Actions', align: 'right', class: "hidden-sm-and-down"}

			],
      pagination: {
        sortBy: 'title',
        descending: true,
        rowsPerPage: 25
      },
      search_text: ""

		}
	},
	filters: {
		channel_name: function(channel_uuid, a) {
			var ch = app.$store.state.channels_uuid[channel_uuid];
			if (typeof(ch) != "undefined") return ChannelModel.title(ch);
			return channel_uuid;
		}
	},
	computed: {
		title_search () {
			return this.search_text;
		},
		instance_list () {
			var self = this;
			var values = _.values(this.$store.state.instances);
			var search = (this.title_search || "").toLowerCase();

			var ret = _.filter(values, function(instance) {
				if (instance.type == self.selected_tab) return true;
				return false;
			});
			if (search.length > 0 ) {
				ret = _.filter(ret, function(instance) {
					ret = false;
					if (instance.title.toLowerCase().includes(search)) ret = true;
					var ip = _.get(instance, "system_info.ip");
					if (!_.isEmpty(ip)) {
						if (ip.includes(search)) ret = true;
					}
					return ret;
				})
			}
			return ret;

		}
	},
	methods: {
		get_field(data, fields, default_value) {
			return _.get(data, fields, default_value);
		},
		get_color (t) {
			if (t == true) return "";
			return "";
		},
		open_edit (id) {
			this.$router.push("/instances/edit/" + id);
		},
		open_add () {
			this.$router.push("/instances/new");
		},
		is_gui (type) {
			if (type == "headend" || type == "clipper" || type == "external_device") return false;
			return true;
		},
		open_gui (item) {
			window.open(InstanceModel.gui_url(item));
		},
		open_ssh (item) {
			window.location.href = InstanceModel.ssh_url(item);
		}
	},
	mounted () {
	}
}
</script>
